import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { ConsentBanner } from "@/analytics/ConsentBanner";
import { MarketingScripts } from "@/analytics/MarketingScripts";
import { env } from "@/lib/env";
import { LandingPage } from "@/pages/LandingPage";
import { Privacy } from "@/pages/Privacy";
import { Terms } from "@/pages/Terms";

const APP_PATH_PREFIXES = [
  "/dashboard",
  "/login",
  "/signup",
  "/reset-password",
  "/invitations",
] as const;

function isLegacyAppPath(pathname: string): boolean {
  return APP_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

function LegacyAppRedirect() {
  const { pathname, search, hash } = useLocation();
  const shouldRedirect = isLegacyAppPath(pathname);

  useEffect(() => {
    if (!shouldRedirect) return;
    const target = `${env.appOrigin}${pathname}${search}${hash}`;
    if (window.location.href !== target) {
      window.location.replace(target);
    }
  }, [hash, pathname, search, shouldRedirect]);

  if (shouldRedirect) return null;
  return <Navigate to="/" replace />;
}

export function LandingApp() {
  return (
    <>
      <MarketingScripts />
      <ConsentBanner />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<LegacyAppRedirect />} />
      </Routes>
    </>
  );
}
